export function intFromString(int: string | undefined): number | undefined {
  if (int !== undefined) {
    return parseInt(int);
  }

  return undefined;
}

const BRANCH_DISPLAY_NAMES: Record<string, string> = {
  airforce: "Air Force",
  army: "Army",
  navy: "Navy",
  marine: "Marines",
  coastguard: "Coast Guard",
  spaceforce: "Space Force",
};

export function formatBranchName(
  branchCode: string | undefined,
): string {
  if (!branchCode) return "-";
  return (
    BRANCH_DISPLAY_NAMES[branchCode.toLowerCase()] ||
    branchCode.charAt(0).toUpperCase() + branchCode.slice(1)
  );
}
